#import "../fragments/EventCancelItemFields.graphql"

query EventCancelPreview($productId: ID!) {
  eventCancelPreview(productId: $productId) {
    productTitle
    purchases
    amount {
      value
      currency
    }
    byProvider {
      provider
      count
      amount {
        value
        currency
      }
    }
    manualItems {
      ...EventCancelItemFields
    }
    free
    liveStreams
    pendingStreams
    sharedStreams
    unknownPayments
  }
}
